var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHuuli(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M15.833 36.6667V29.1667H24.1663V36.6667L19.9997 34.1667L15.833 36.6667Z",
    fill: "#0E308E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M33.3332 20V10C33.3332 6.31811 30.3484 3.33334 26.6665 3.33334H13.3332C9.65127 3.33334 6.6665 6.3181 6.6665 10V20C6.6665 23.6819 9.65127 26.6667 13.3332 26.6667L26.6665 26.6667C30.3484 26.6667 33.3332 23.6819 33.3332 20Z",
    fill: "#0E308E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25 26.6667C25 29.4281 22.7614 31.6667 20 31.6667C17.2386 31.6667 15 29.4281 15 26.6667C15 23.9052 17.2386 21.6667 20 21.6667C22.7614 21.6667 25 23.9052 25 26.6667Z",
    fill: "#0E308E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.083 10C12.083 9.30964 12.6427 8.75 13.333 8.75H26.6663C27.3567 8.75 27.9163 9.30964 27.9163 10C27.9163 10.6904 27.3567 11.25 26.6663 11.25H13.333C12.6427 11.25 12.083 10.6904 12.083 10Z",
    fill: "#0E308E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.083 16.6667C12.083 15.9763 12.6427 15.4167 13.333 15.4167H19.9997C20.69 15.4167 21.2497 15.9763 21.2497 16.6667C21.2497 17.357 20.69 17.9167 19.9997 17.9167H13.333C12.6427 17.9167 12.083 17.357 12.083 16.6667Z",
    fill: "#0E308E"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHuuli);
export default __webpack_public_path__ + "static/media/huuli.fc935eb1ca7eabe1b10cb29da5f92e67.svg";
export { ForwardRef as ReactComponent };